import { createSlice } from '@reduxjs/toolkit';

export const hoverElementSlice = createSlice({
	name: 'hoverElement',
	initialState: {
		value: {
			componentId: null,
			componentName: null,
		},
	},
	reducers: {
		setHoverElement: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setHoverElement } = hoverElementSlice.actions;
export const hoverElement = (state) => state.hoverElement.value;
export default hoverElementSlice.reducer;
